/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Cluster, Chain, Network } from '../types/networks';
import { 
    SOLANA_MAINNET_RPC, 
    SOLANA_DEVNET_RPC, 
    SUI_MAINNET_RPC, 
    SUI_DEVNET_RPC 
} from './constants';

export const CLUSTERS: Cluster[] = [
    {
        id: 'solana-mainnet',
        name: 'Solana Mainnet Beta',
        chain: 'SOL',
        network: 'mainnet',
        rpcUrl: SOLANA_MAINNET_RPC,
        explorerUrl: 'https://solscan.io',
        nativeCurrency: {
            name: 'Solana',
            symbol: 'SOL',
            decimals: 9,
            logo: 'https://cryptologos.cc/logos/solana-sol-logo.png'
        },
        color: 'from-purple-500 to-indigo-600'
    },
    {
        id: 'solana-devnet',
        name: 'Solana Devnet',
        chain: 'SOL',
        network: 'devnet',
        rpcUrl: SOLANA_DEVNET_RPC,
        explorerUrl: 'https://solscan.io?cluster=devnet',
        nativeCurrency: {
            name: 'Solana',
            symbol: 'SOL',
            decimals: 9,
            logo: 'https://cryptologos.cc/logos/solana-sol-logo.png'
        },
        color: 'from-purple-400 to-indigo-400'
    },
    {
        id: 'sui-mainnet',
        name: 'Sui Mainnet',
        chain: 'SUI',
        network: 'mainnet',
        rpcUrl: SUI_MAINNET_RPC,
        explorerUrl: 'https://suiscan.xyz',
        nativeCurrency: {
            name: 'Sui',
            symbol: 'SUI',
            decimals: 9,
            logo: 'https://cryptologos.cc/logos/sui-sui-logo.png'
        },
        color: 'from-blue-400 to-cyan-500'
    },
    {
        id: 'sui-devnet',
        name: 'Sui Devnet',
        chain: 'SUI',
        network: 'devnet',
        rpcUrl: SUI_DEVNET_RPC,
        explorerUrl: 'https://suiscan.xyz/network/devnet',
        nativeCurrency: {
            name: 'Sui',
            symbol: 'SUI',
            decimals: 9,
            logo: 'https://cryptologos.cc/logos/sui-sui-logo.png'
        },
        color: 'from-blue-300 to-cyan-400'
    }
];

export const getCluster = (chain: Chain, network: Network): Cluster => {
    return CLUSTERS.find(c => c.chain === chain && c.network === network) || CLUSTERS[0];
};

export const getAvailableNetworks = (chain: Chain): Cluster[] => {
    return CLUSTERS.filter(c => c.chain === chain);
};